/**
 * The public IP question of a Dedicated server and the words around it. The one place to change them on this side. The quota messages the
 * backend sends are shown as they come (`GET /infrastructure/public-ip-quota/`); only the one for a request that failed is worded here.
 */

/** Asked of a Dedicated RDS server (all its RDS VMs) and of a Dedicated SQL server VM. Never of an Existing server or an Azure SQL (PaaS) server. */
export const PUBLIC_IP_QUESTION = 'Do you need a public IP for this server?'

/** Said whenever the answer is Yes. The portal creates no NSG: the subnet's own decides who can reach the server. */
export const PUBLIC_IP_NSG_NOTE = "A public IP exposes this server to the internet. Access is controlled by the subnet's NSG."

/** What the Review step adds to a Yes: the kind of public IP, so nobody has to guess. */
export const PUBLIC_IP_KIND = 'Standard, static'

/**
 * The RDS answer covers every RDS VM created together: what that means, for the number of RDS VMs and the answer. Nothing to say for one RDS
 * VM that is not given a public IP.
 */
export function rdsPublicIpCoverage(count: number, publicIp: boolean): string | null {
  if (publicIp) return count === 1 ? 'One public IP is created for the RDS VM.' : `One public IP is created for each of the ${count} RDS VMs.`
  return count === 1 ? null : `The answer covers all ${count} RDS VMs created together.`
}

/** What is said when the quota could not be asked at all (the request itself failed): the backend's own wording is for an answer it did give. */
export const PUBLIC_IP_QUOTA_REQUEST_FAILED = "Couldn't verify public IP quota."

/** In "To continue" while the quota is being asked: Next waits for the answer. */
export const PUBLIC_IP_QUOTA_CHECKING = 'Checking the public IP quota…'
